(() => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
  });
  nav?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    nav.classList.remove('is-open'); menu?.setAttribute('aria-expanded', 'false');
  }));
  const searchToggle = document.querySelector('.search-toggle');
  const search = document.querySelector('.site-search');
  searchToggle?.addEventListener('click', () => {
    const open = search?.hidden;
    if (search) search.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) search.querySelector('input[type="search"]')?.focus();
  });

  const filters = document.querySelectorAll('[data-filter]');
  const cards = document.querySelectorAll('.product-card[data-type]');
  filters.forEach(button => button.addEventListener('click', () => {
    const filter = button.dataset.filter;
    filters.forEach(b => { b.classList.toggle('active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
    let visible = 0;
    cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.type !== filter; if (!card.hidden) visible++; });
    const empty = document.querySelector('.filter-empty');
    if (empty) empty.hidden = visible !== 0;
  }));

  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const slides = [...gallery.querySelectorAll('.gallery-slide')];
    const thumbs = [...gallery.querySelectorAll('.gallery-thumb')];
    let active = 0;
    const show = index => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('is-active', i === active); });
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === active); thumb.setAttribute('aria-pressed', String(i === active)); });
      const count = gallery.querySelector('.gallery-count');
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      thumbs[active]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    gallery.querySelector('.gallery-arrow.prev')?.addEventListener('click', () => show(active - 1));
    gallery.querySelector('.gallery-arrow.next')?.addEventListener('click', () => show(active + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    let startX = null;
    const viewport = gallery.querySelector('.gallery-viewport');
    viewport?.addEventListener('touchstart', e => { startX = e.touches[0]?.clientX ?? null; }, { passive: true });
    viewport?.addEventListener('touchend', e => {
      if (startX === null) return;
      const delta = (e.changedTouches[0]?.clientX ?? startX) - startX;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
    gallery.selectMedia = mediaId => {
      const idx = slides.findIndex(slide => slide.dataset.mediaId === String(mediaId));
      if (idx !== -1) show(idx);
    };
  }

  const product = document.querySelector('[data-product-page]');
  const variantData = document.querySelector('#product-variants');
  if (product && variantData) {
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (e) { console.error('Product options unavailable', e); }
    const form = document.querySelector('#product-buy-form');
    const idInput = form?.querySelector('[data-variant-id]');
    const price = product.querySelector('[data-product-price]');
    const message = product.querySelector('[data-variant-message]');
    const buy = product.querySelector('[data-buy-button]');
    const sticky = document.querySelector('[data-sticky-buy]');
    const groups = [...product.querySelectorAll('.option-group')];
    const update = () => {
      const chosen = groups.map(group => group.querySelector('input:checked')?.value);
      const variant = groups.length ? variants.find(v => v.options.every((opt, i) => opt === chosen[i])) : variants[0];
      if (idInput) idInput.value = variant?.id || '';
      if (price && variant) price.textContent = variant.price;
      const canBuy = Boolean(variant?.available);
      for (const button of [buy, sticky]) if (button) { button.disabled = !canBuy; button.textContent = canBuy ? 'ADD TO BAG →' : variant ? 'SOLD OUT' : 'UNAVAILABLE'; }
      if (message) message.textContent = variant ? '' : 'This combination is unavailable. Choose another size or color.';
      if (variant?.mediaId) gallery?.selectMedia?.(variant.mediaId);
      if (variant && window.history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    groups.forEach(group => group.addEventListener('change', update));
    update();
  }
})();
